import { createContext } from 'react';
import { UnsavedChangesType } from './types';

const UnsavedChangesContext = createContext<UnsavedChangesType>({
  action: false,
  setAction: () => {},
  showDialog: () => {},
  cleanAction: () => {},
  isVisible: false,
});

export default UnsavedChangesContext;
